import React from 'react'
import styled from '@emotion/styled'

import Layout from 'components/layouts/signIn'
import { TYPOGRAPHY_18 } from 'theme/theme'
import FormSubTitle from 'components/forms/subTitle'
import Input from 'components/forms/styledInput'

const Text = styled.div`
  ${TYPOGRAPHY_18}

  color: #a0a5b3;

  @media (max-width: 767px) {
    text-align: center;
  }
`

export default function MediaPage () {
  return (
    <Layout sTitle="Media" title="Media" description="Media" path="/media" noCB={true}>
      <FormSubTitle t="Logos" className="mb-20" />

      <Text>200px x 70px</Text>
      <a href="https://shareline.co"><img src="/s/media/200x70.png" alt="Shareline: Invest in Top Private Tech Companies" /></a>
      <Input className="mb-20" defaultValue={'<a href="https://shareline.co"><img src="https://shareline.co/s/media/200x70.png" alt="Shareline: Invest in Top Private Tech Companies" /></a>'} />

      <Text>200px x 100px</Text>
      <img src="/s/media/200x100.png" alt="Shareline: Invest in Top Private Tech Companies" />
      <Input className="mb-20" defaultValue={'<a href="https://shareline.co"><img src="https://shareline.co/s/media/200x100.png" alt="Shareline: Invest in Top Private Tech Companies" /></a>'} />

      <Text>250px x 150px</Text>
      <img src="/s/media/250x150.png" alt="Shareline: Invest in Top Private Tech Companies" />
      <Input className="mb-20" defaultValue={'<a href="https://shareline.co"><img src="https://shareline.co/s/media/250x150.png" alt="Shareline: Invest in Top Private Tech Companies" /></a>'} />

      <Text>300px x 150px</Text>
      <img src="/s/media/300x150.png" alt="Shareline: Invest in Top Private Tech Companies" />
      <Input className="mb-20" defaultValue={'<a href="https://shareline.co"><img src="https://shareline.co/s/media/300x150.png" alt="Shareline: Invest in Top Private Tech Companies" /></a>'} />
    </Layout>
  )
}
